
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":"3.5","width":"17","height":"17","rx":"3.5","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M13.3 12.8H9.66v3.58H7.98V12.8H4.34v-1.58h3.64v-3.6h1.68v3.6h3.64v1.58z","fill":"currentColor"}})])
          )
        }
      }
    